import { useEffect, useState } from "react";
import MainLayout from "../layout/main-layout";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../Components/loader/loader";
import { ChevronLeft } from "lucide-react";
import CTASection from "../Components/common-section/cta-section";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "react-device-frameset/styles/marvel-devices.min.css";
import OtherCases from "../Components/case-study/other-cases";

function OurWorkDetail() {
  const { id, title } = useParams();
  const [work, setWork] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [cases, setCases] = useState([]);
  const navigate = useNavigate();

  const fetchCases = () => {
    axios
      .get(`case_studies`)
      .then((res) => {
        if (res.status === 200) {
          const cases = res.data;
          setCases(cases);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchData = () => {
    axios
      .get(`case_studies/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setWork(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleNavigate = (data: any) => {
    navigate(`/our-work/${data.id}/${data.title}`);
  };

  useEffect(() => {
    setWork({});
    setLoading(true);
    fetchData();
    fetchCases();
  }, [id]);

  const techStack = [
    work?.backend_tech,
    work?.database_tech,
    work?.frontend_tech,
    work?.domain,
  ].filter(Boolean);

  return (
    <MainLayout>
      {loading ? (
        <section className="w-full min-h-screen h-full relative flex flex-col items-start justify-center lg:p-16 p-8 mt-16">
          <Loader />
        </section>
      ) : (
        <>
          <section
            className="relative min-h-screen flex flex-col px-4 sm:px-6 md:px-10 lg:px-16 py-44"
            style={{
              background: `#${work?.bg_color}`,
            }}
          >
            <div className="flex items-center justify-center flex-col md:flex-row w-full gap-8">
              <div className="md:w-1/2 flex flex-col gap-8 items-start justify-center">
                <button
                  style={{
                    color: `#${work?.text_color}`,
                    borderColor: `#${work?.text_color}`,
                  }}
                  onClick={() => navigate(-1)}
                  className="flex gap-2 items-center px-4 py-2 border-2 rounded-full "
                >
                  <ChevronLeft color={`#${work?.text_color || `000`}`} />
                  Back
                </button>
                {work?.domain && (
                  <h2
                    className="text-sm tracking-wide"
                    style={{ color: `#${work?.text_color}` }}
                  >
                    {work?.domain}
                  </h2>
                )}
                <h2
                  className="text-5xl font-semibold tracking-wider"
                  style={{ color: `#${work?.text_color}` }}
                >
                  {work?.title}
                </h2>
                <p
                  className="text-sm font-light tracking-wide"
                  style={{ color: `#${work?.text_color}` }}
                >
                  {work?.description}
                </p>
                {work?.is_case_studies && (
                  <button
                    style={{
                      color: `#${work?.text_color}`,
                      borderColor: `#${work?.text_color}`,
                    }}
                    onClick={() =>
                      navigate(`/case-study/${work?.id}/${work?.title}`)
                    }
                    className="flex gap-2 items-center px-4 py-2 border-2 rounded-full"
                  >
                    Read More
                  </button>
                )}
              </div>
              <div className="md:w-1/2 flex items-center justify-center">
                <img src={work?.main_image_url} className="w-full h-auto" />
              </div>
            </div>
            <div className="w-full bg-white p-4 absolute bottom-0 left-0">
              <div className="flex items-center w-full justify-center flex-wrap gap-4">
                {techStack.map((name, index) => (
                  <span
                    key={index}
                    className="relative text-sm font-medium bg-gradient-to-r from-blue-50 to-indigo-100 text-blue-800 px-4 py-2 rounded-full border border-blue-200 hover:from-blue-100 hover:to-indigo-200 hover:scale-105 transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md"
                  >
                    {name}
                  </span>
                ))}
              </div>
            </div>
          </section>
        </>
      )}

      <OtherCases
        cases={cases}
        heading="Other Works"
        handleNavigate={handleNavigate}
        buttonTitle="View"
      />
      <CTASection />
    </MainLayout>
  );
}

export default OurWorkDetail;
